module.exports = __webpack_public_path__ + "media/assets/img/products/studio_international-not-selected-c45f999f6811c80488272f4bf23c96e1.svg";